import BaseService from "./BaseService";

class CertificateService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/certificates?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/certificates`, "POST", data);
  }

  static async delete({ id }) {
    return await BaseService.callAPI(`/certificates/${id}`, "DELETE");
  }
}

export default CertificateService;
